import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { PrefillResumeEvents } from 'builder/modules/constants'
import createNewResumeImage from '../assets/create-new-resume.svg'
import { CreateNewResumeProps } from '../types'
import {
  Card,
  CardTitleWrapper,
  CardTitle,
  ImageWrapper,
  Image,
  IconWrapper,
  ArrowIcon,
} from './styles'

export const CreateNewResume = ({ onClose, onClick }: CreateNewResumeProps) => {
  const { i18n } = useI18n()

  const handleCardClick = () => {
    trackInternalEvent(PrefillResumeEvents.clickCreateResume)
    onClick && onClick()
    onClose()
  }

  return (
    <Card onClick={handleCardClick}>
      <ImageWrapper>
        <Image src={createNewResumeImage} alt="Create New Resume" />
      </ImageWrapper>
      <CardTitleWrapper>
        <CardTitle>{i18n.t('builder.prefill_resume.create_resume')}</CardTitle>
      </CardTitleWrapper>
      <IconWrapper>
        <ArrowIcon />
      </IconWrapper>
    </Card>
  )
}
